import { useEffect, useRef, useState } from 'react';
import {
  Flex,
  Heading,
  Input,
  Text,
} from '@chakra-ui/react';

interface CustomTitleProps {
  type: string;
  index?: number;
  customTitle?: string;
  updateFunction: (newTitle: string) => void;
}

export const CustomTitle: React.FC<CustomTitleProps> = ({
  type,
  index,
  customTitle,
  updateFunction,
}) => {
  const [editingTitle, setEditingTitle] = useState(false);
  const [title, setTitle] = useState(customTitle || '');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const saveTitle = () => {
    updateFunction(title);
    setEditingTitle(false);
  };

  useEffect(() => {
    if (editingTitle && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editingTitle]);

  return (
    <Flex alignItems="center" gap={4}>
      <Heading size="md" fontWeight="bold" whiteSpace="nowrap">
        {type} {index != null && index}
      </Heading>

      {editingTitle ? (
        <Input
          value={title}
          onChange={handleTitleChange}
          onBlur={saveTitle}
          onKeyDown={(e) => e.key === 'Enter' && saveTitle()}
          size="md"
          ref={inputRef}
          flex="1"
        />
      ) : (
        <Text
          cursor="pointer"
          onClick={() => setEditingTitle(true)}
          fontWeight="medium"
          flex="1"
          noOfLines={1}
          isTruncated
        >
          {customTitle || 'Custom Title Here'}
          {/* {'Custom Title Here'} */}
        </Text>
      )}
    </Flex>
  );
};
